import React, { PropTypes } from 'react';
import * as B from 'react-bootstrap';
import { MESSAGE_FROM } from 'reducers/chat/main';
import ChatMessage from './ChatMessage';

const ChatMessageGroup = ({ messages }) => {
  let first = messages.first(), i = -1;
  return (
    <div className={`chat-message-group ${first.from}`}>
      <span className="chat-message-group-name">{first.name}</span>
      <span className="chat-message-group-time">{first.sent.fromNow()}</span>
      <B.Well bsSize="small" bsStyle={first.bsStyle} className="chat-message-group-messages">
        {
          messages.toArray().map(m => (
            <ChatMessage
              key={i += 1}
              className="chat-message-group-message"
              message={m}
            />
          ))
        }
      </B.Well>
      <div className="clearfix"></div>
    </div>
  );
}

ChatMessageGroup.propTypes = {
  messages: PropTypes.object.isRequired,
};

export default ChatMessageGroup;



// WEBPACK FOOTER //
// ./components/chat/ChatMessageGroup.js